"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgError(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0a8 8 0 110 16 8 8 0 010-16zm.944 11H11v1.896h1.944zm.124-7h-2.136v.237L11.496 10h1.008l.564-5.763z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Error')(SvgError);
//# sourceMappingURL=Error.js.map